module.exports = __webpack_public_path__ + "static/brain-e81433f8763f7ad0eef6e77df80c585d.png";